<template>
  <v-app >
    <v-main>
      <v-fade-transition>
        <router-view></router-view>
      </v-fade-transition>
      </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    introduced:false
  }),
  methods:{
    async pass(){
      this.introduced=true
    }
  }
};
</script>
<style lang="css">
.vue-typer .left { display: inline-block; }
.vue-typer {
  font-family: monospace;
}

.vue-typer .custom.char {
  color: #D4D4BD;
}

.vue-typer .custom.caret {
  width: 10px;
  background-color:  #D4D4BD;
}
</style>